$bog_smalljs_versus $mol_view
	framework_title* \
	vs_text @ \vs
	row_partial_template @ \Ranked on {n} of {total} metrics
	auto /
		<= pick_sync null
	sub /
		<= Head $mol_view
			sub /
				<= Title $mol_view
					dom_name \h1
					sub /
						<= title_text @ \Compare frameworks
				<= Intro $mol_view
					sub /
						<= intro_text @ \Pick two frameworks and see where they differ. Every number carries the source it came from and the date it was measured, and the crash tests run live in your own browser.
		<= Picker $mol_view
			sub /
				<= Pick_a $mol_search
					hint @ \React…
					query? <=> query_a? \
					suggests <= suggests_a /
				<= Vs $mol_view
					sub /
						<= vs_text
				<= Pick_b $mol_search
					hint @ \Vue…
					query? <=> query_b? \
					suggests <= suggests_b /
		<= Popular $mol_view
			sub /
				<= Popular_title $mol_view
					dom_name \h2
					sub /
						<= popular_title @ \Popular comparisons
				<= Popular_list $mol_view
					sub <= popular_links /
		<= Top_apps $mol_view
			sub /
				<= Top_apps_title $mol_view
					dom_name \h2
					sub /
						<= top_apps_title @ \Best for apps
				<= Top_apps_note $mol_view
					sub /
						<= top_apps_note @ \Ranked by categories won in Speed and Code.
				<= Top_apps_list $mol_view
					sub <= top_apps_content /
		<= Top_sites $mol_view
			sub /
				<= Top_sites_title $mol_view
					dom_name \h2
					sub /
						<= top_sites_title @ \Best for content sites
				<= Top_sites_note $mol_view
					sub /
						<= top_sites_note @ \Ranked by categories won in Weight and Built-in.
				<= Top_sites_list $mol_view
					sub <= top_sites_content /
		<= Rating $mol_view
			sub /
				<= Rating_title $mol_view
					dom_name \h2
					sub /
						<= rating_title @ \All frameworks
				<= Rating_note $mol_view
					sub /
						<= rating_note @ \Ranked by categories won against every other framework. A category counts only the metrics both sides publish, so a fuller table is no advantage in itself.
				<= Rating_head $mol_view
					sub /
						<= Rating_head_rank $mol_view
							sub /
								<= rating_head_rank @ \#
						<= Rating_head_mark $mol_view
						<= Rating_head_name $mol_view
							sub /
								<= rating_head_name @ \Framework
						<= Rating_head_score $mol_view
							sub /
								<= rating_head_score @ \Categories won
						<= Rating_head_since $mol_view
							sub /
								<= rating_head_since @ \Since
				<= Rating_list $mol_view
					sub <= rating_content /
				<= Pager $mol_view
					sub <= pager_content /
		<= Method $mol_view
			sub /
				<= Method_title $mol_view
					dom_name \h2
					sub /
						<= method_title_text @ \How this is measured
				<= Method_text $mol_view
					sub /
						<= method_body @ \Every number on a comparison page carries the source it came from and the date it was taken, and a metric nobody measured is absent rather than guessed. The live cases are one scenario written once per framework, with the same steps and the same timings, read inside the frame right after the run. The sources of all of it live in the repository, so you can read them, run them locally, or open an issue if something looks unfair.
				<= Method_link $mol_link
					uri \https://github.com/b-on-g/smalljs/tree/master/versus
					sub /
						<= method_link_label @ \Method and sources on GitHub
						<= Method_link_icon $mol_icon_open_in_new
	Popular_link* $mol_link
		arg <= pair_arg* *
		sub /
			<= Popular_left* $mol_view
				dom_name \strong
				sub /
					<= pair_left* \
			<= Popular_mid* $mol_view
				sub /
					<= vs_text
			<= Popular_right* $mol_view
				dom_name \strong
				sub /
					<= pair_right* \
	Card* $bog_smalljs_versus_pick
		arg <= card_arg* *
		sub /
			<= Card_mark* $mol_view
				sub /
					<= card_mark* \
			<= Card_name* $mol_view
				sub /
					<= card_name* \
	Row* $mol_view
		sub <= row_content* /
	Rank* $mol_view
		sub /
			<= rank* \
	Row_mark* $mol_view
		sub /
			<= row_mark* \
	Row_name* $mol_view
		sub <= row_name_content* /
	Row_link* $bog_smalljs_versus_pick
		arg <= row_arg* *
		sub /
			<= row_title* \
	Row_partial* $mol_view
		sub /
			<= row_partial_text* \
	Row_score* $mol_view
		sub /
			<= Row_track* $mol_view
				sub /
					<= Row_fill* $mol_view
						style *
							width <= row_fill_width* \0%
			<= Row_value* $mol_view
				sub /
					<= row_score_text* \
	Row_since* $mol_view
		sub /
			<= row_since_text* \
	Page* $mol_button_minor
		click? <=> page_click*? null
		attr *
			^
			bog_smalljs_versus_page_current <= page_current* false
		sub /
			<= page_label* \
	Page_next $mol_button_minor
		hint <= page_next_hint @ \Next page
		click? <=> page_next? null
		sub /
			<= page_next_label \›
	Empty* $mol_view
		sub /
			<= empty_text @ \No measurements published yet. Every row here waits for a real number with a source and a date behind it.

$bog_smalljs_versus_pick $mol_link
	uri_off <= uri
